import { render } from "./CartInfoSend.vue?vue&type=template&id=3cecff15&scoped=true"
import script from "./CartInfoSend.vue?vue&type=script&lang=js"
export * from "./CartInfoSend.vue?vue&type=script&lang=js"

import "./CartInfoSend.vue?vue&type=style&index=0&id=3cecff15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cecff15"]])

export default __exports__